import React from "react";
import styles from "./tailored.module.css";
import tradingStylesImage from "../../../assets/trading_styles_professional.jpg"; // 👈 New image

export default function TailoredToMatch() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.textContent}>
            <h2>Tailored to Match <span>Your Trading Style</span></h2>
            <p className={styles.subtitle}>
              Whether you're a beginner taking your first steps, an experienced trader 
              refining your strategy, or a professional managing significant portfolios, 
              StoneForex delivers personalized solutions that evolve with your journey.
            </p>
            
            <div className={styles.tradingStyles}>
              <div className={styles.styleCard}>
                <div className={styles.styleIcon}>
                  <span>🎯</span>
                </div>
                <h3>Beginner Friendly</h3>
                <p>Educational resources, demo accounts, and guided onboarding to build your confidence.</p>
              </div>
              
              <div className={styles.styleCard}>
                <div className={styles.styleIcon}>
                  <span>📊</span>
                </div>
                <h3>Advanced Tools</h3>
                <p>Professional charting, technical analysis, and automated trading capabilities.</p>
              </div>
              
              <div className={styles.styleCard}>
                <div className={styles.styleIcon}>
                  <span>💎</span>
                </div>
                <h3>Premium Service</h3>
                <p>Dedicated support, exclusive research, and institutional-grade execution.</p>
              </div>
            </div>
            
            <button className={styles.exploreButton}>Explore Account Types</button>
          </div>
          
          <div className={styles.imageContent}>
            <div className={styles.imageWrapper}>
              <img src={tradingStylesImage} alt="Professional traders with different experience levels" />
              <div className={styles.imageOverlay}>
                <div className={styles.statsBadge}>
                  <div className={styles.statItem}>
                    <span className={styles.statNumber}>4</span>
                    <span className={styles.statLabel}>Account Types</span>
                  </div>
                  <div className={styles.statItem}>
                    <span className={styles.statNumber}>24/7</span>
                    <span className={styles.statLabel}>Support</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
